import styled, { DefaultTheme } from 'styled-components';
import { Button } from 'antd';

declare module 'styled-components' {
  export interface DefaultTheme {
    mode?: 'light' | 'dark';
  }
}

const getThemeValue = <T,>(props: { theme?: DefaultTheme }, darkValue: T, lightValue: T): T => {
  return props.theme?.mode === 'dark' ? darkValue : lightValue;
};

export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;

  @media (min-width: 640px) {
    width: auto;
  }
`;

export const DropdownButton = styled(Button)`
  width: 100%;
  min-width: 150px;
  height: 38px;
  background-color: #2D6CCA !important;
  color: #ffffff !important;
  border-color: #2D6CCA !important;
  font-size: 16px !important;
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover,
  &:focus {
    background-color: #1e4d8f !important;
    border-color: #1e4d8f !important;
    color: #ffffff !important;
  }

  @media (min-width: 640px) {
    width: 180px;
  }
`;

